<template>
    <div class="v-icon mr-2 ">
        <v-dialog
            :value="editPersonPhoneNumberDialog"
            max-width="700px"
            persistent
        >
            <v-card v-if="editPersonPhoneNumberDialog">
                <v-card-title
                    class="pt-1 pb-1 headline grey lighten-2"
                    color="primary"
                    primary-title
                >
                    <span class="headline">Edit Person Phone Number</span>
                    <v-spacer />
                    <v-btn
                        @click.stop="closeEditItem()"
                        fab
                        rounded
                        small
                        text
                    >
                        X
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container
                        grid-list-md
                        pt-0
                    >
                        <v-layout wrap>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-text-field
                                    :error-messages="editContactNumberErrors"
                                    @blur="$v.editContactNumber.$touch()"
                                    @input="$v.editContactNumber.$touch()"
                                    label="Contact Number"
                                    type="text"
                                    v-model="editContactNumber"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    :error-messages="editTypeErrors"
                                    :items="phoneNumberTypeList"
                                    @blur="$v.editType.$touch()"
                                    @input="$v.editType.$touch()"
                                    item-text="name"
                                    item-value="type"
                                    label="Type"
                                    v-model="editType"
                                />
                            </v-flex>
                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    :error-messages="editCategoryErrors"
                                    :items="phoneNumberCategoryList"
                                    @blur="$v.editType.$touch()"
                                    @input="$v.editType.$touch()"
                                    item-text="name"
                                    item-value="category"
                                    label="Category"
                                    v-model="editCategory"
                                />
                            </v-flex>

                            <v-flex
                                md12
                                sm12
                                xs12
                            >
                                <v-select
                                    v-if="hasPhoneNumberInContactList.showInContactList && hasPhoneNumberInContactList.personPhoneNumberId != editPersonPhoneNumberId"
                                    :error-messages="editShowInContactListErrors"
                                    :items="[{Id: false, name: 'No'}]"
                                    @blur="$v.editShowInContactList.$touch()"
                                    @input="$v.editShowInContactList.$touch()"
                                    item-text="name"
                                    item-value="Id"
                                    label="Show In Contact List"
                                    v-model="editShowInContactList"
                                />
                                <v-select
                                    v-else
                                    :error-messages="editShowInContactListErrors"
                                    :items="[{Id: true, name: 'Yes'}, {Id: false, name: 'No'}]"
                                    @blur="$v.editShowInContactList.$touch()"
                                    @input="$v.editShowInContactList.$touch()"
                                    item-text="name"
                                    item-value="Id"
                                    label="Show In Contact List"
                                    v-model="editShowInContactList"
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        @click="saveEditItemAndCloseDialog"
                        color="green"
                        text
                    >
                        Save
                    </v-btn>
                    <v-btn
                        @click="closeEditItem"
                        color="red darken-1"
                        text
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    import {mapActions, mapGetters, mapMutations} from "vuex";
    import EditTableFunctions from '../editTableFunctions';
    import {SAVE_PERSON_PHONE_NUMBER} from "@/store/person_phone_number/actions.js";
    import {LOAD_PERSON_PHONE_NUMBER_TO_EDIT, RESET_DEFAULT_PERSON_PHONE_NUMBER_TO_EDIT, TOGGLE_EDIT_PERSON_PHONE_NUMBER_DIALOG, UPDATE_PERSON_PHONE_NUMBER_FIELD} from "@/store/person_phone_number/mutations.js"
    import {SET_EDIT_PERSON_FORM_SECTION_STATE} from "@/store/person/mutations";
    import {helpers, required} from 'vuelidate/lib/validators'

    // eslint-disable-next-line no-useless-escape
    const phone = helpers.regex('alpha', /^(\+\s?)?((^\+.*)\(\+?\d+([\s\-\.]?\d+)?\)|\d+)([\s\-\.]?(\(\d+([\s\-\.]?\d+)?\)|\d+))*(\s?(x|ext\.?)\s?\d+)?$/);

    export default {
        name: "EditPersonPhoneNumberDialog",
        validations: {
            editContactNumber: {phone, required},
            editType: {required},
            editCategory: {required},
            editShowInContactList: {required}
        },
        components: {},
        mixins: [
            EditTableFunctions,
        ],
        props: {
            personId: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                // Required for editTableFunctions
                idName: 'personPhoneNumberId',
            }
        },
        computed: {
            editPersonPhoneNumberId: {
                get() {
                    return this.$store.state.person_phone_number.editPersonPhoneNumber.personPhoneNumberId;
                }
            },

            editContactNumber: {
                get() {
                    return this.$store.state.person_phone_number.editPersonPhoneNumber.contactNumber;
                },
                set(value) {
                    this.updatePersonPhoneNumber('contactNumber', value);
                }
            },

            editContactNumberErrors() {
                const errors = [];
                if (!this.$v.editContactNumber.$dirty) {
                    return errors;
                }
                if (!this.$v.editContactNumber.required) {
                    errors.push('Required.');
                }
                if (!this.$v.editContactNumber.phone) {
                    errors.push('Must be a valid phone number.');
                }

                return errors
            },

            editType: {
                get() {
                    return this.$store.state.person_phone_number.editPersonPhoneNumber.type;
                },
                set(value) {
                    this.updatePersonPhoneNumber('type', value);
                }
            },

            editTypeErrors() {
                const errors = [];
                if (!this.$v.editType.$dirty) return errors;
                !this.$v.editType.required && errors.push('required.');
                return errors
            },
            editCategory: {
                get() {
                    return this.$store.state.person_phone_number.editPersonPhoneNumber.category;
                },
                set(value) {
                    this.updatePersonPhoneNumber('category', value);
                }
            },
            editCategoryErrors() {
                const errors = [];
                if (!this.$v.editCategory.$dirty) return errors;
                !this.$v.editCategory.required && errors.push('required.');
                return errors
            },
            editShowInContactList: {
                get() {
                    return this.$store.state.person_phone_number.editPersonPhoneNumber.showInContactList;
                },
                set(value) {
                    this.updatePersonPhoneNumber('showInContactList', value);
                }
            },
            editShowInContactListErrors() {
                const errors = [];
                if (!this.$v.editShowInContactList.$dirty) return errors;
                !this.$v.editShowInContactList.required && errors.push('required.');
                return errors
            },
            ...mapGetters(
            [
                "editPersonPhoneNumberDialog",
                "phoneNumberCategoryList",
                "phoneNumberTypeList",
                "person",
                "hasPhoneNumberInContactList",
            ]
            ),
            ...mapGetters({
                id: "editPersonPhoneNumberId"
            })
        },
        mounted() {
        },
        methods: {
            validate() {
                this.$v.$touch();

                let formState = false;

                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }

                this.$store.commit(SET_EDIT_PERSON_FORM_SECTION_STATE, {section: 'bankDetail', state: formState});
            },
            updatePersonPhoneNumber(field, value) {
                let data = {};
                data.field = field;
                data.value = value;
                this.$store.commit(UPDATE_PERSON_PHONE_NUMBER_FIELD, data);
            },
            toggleEditPersonSummaryDialog() {
                this.$store.commit(TOGGLE_EDIT_PERSON_PHONE_NUMBER_DIALOG);
            },
            ...mapActions({
                updateTableItemRecord: SAVE_PERSON_PHONE_NUMBER,
            }),
            //
            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_PERSON_PHONE_NUMBER_DIALOG,
                loadTableItemToEdit: LOAD_PERSON_PHONE_NUMBER_TO_EDIT,
                // updateTableItemToEdit: ,
                resetEditItemToDefault: RESET_DEFAULT_PERSON_PHONE_NUMBER_TO_EDIT,
            }),
        },
    }
</script>

<style scoped>
</style>
